export default __webpack_public_path__ + "static/media/award.41e3c86d.svg";